import { render, staticRenderFns } from "./OrderTypeManagement.vue?vue&type=template&id=41c2388a"
import script from "./OrderTypeManagement.vue?vue&type=script&lang=js"
export * from "./OrderTypeManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports